(() => {
  const root = document.querySelector('#MainContent');
  if (!root) return;
  const signatures = new WeakMap();
  function updateShelves() {
    const recommendations = root.querySelector('.ss-you-may-also-like');
    // Preserve Shopify's original adaptive selection and wait for it to settle.
    if (recommendations && recommendations.dataset.loaded !== 'true') return;
    const recommendedHandles = new Set(
      Array.from(recommendations?.querySelectorAll('[data-recommendation-items] a[href*="/products/"]') || [])
        .map(link => new URL(link.href).pathname.split('/products/')[1]?.split('/')[0])
        .filter(Boolean)
    );
    root.querySelectorAll('.ss-brand-bundles').forEach(section => {
      const pool = section.querySelector('[data-brand-shelf-candidates]');
      const grid = section.querySelector('[data-brand-shelf]');
      const heading = section.querySelector('[data-brand-shelf-heading]');
      if (!pool || !grid || !heading) return;
      const choices = Array.from(pool.content.querySelectorAll('[data-brand-product]'))
        .filter(card => !recommendedHandles.has(card.dataset.brandProduct)).slice(0, 4);
      const signature = choices.map(card => card.dataset.brandProduct).join('|');
      if (signatures.get(section) === signature) return;
      signatures.set(section, signature);
      grid.replaceChildren(...choices.map(card => card.cloneNode(true)));
      grid.hidden = choices.length === 0;
      heading.hidden = choices.length === 0;
    });
  }
  new MutationObserver(updateShelves).observe(root, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['data-loaded']
  });
  updateShelves();
})();